import {
  CeaseActionTypes,
  ICreateCease,
  ICreateCeaseEnded,
  ICreateCeaseError,
  ICreateCeaseStarted,
  ICreateCeaseSuccess,
  IGetCease,
  IGetCeaseEnded,
  IGetCeaseError,
  IGetCeaseStarted,
  IGetCeaseSuccess,
  IGetCeases,
  IGetCeasesEnded,
  IGetCeasesError,
  IGetCeasesStarted,
  IGetCeasesSuccess,
  IResetCeaseError,
  ISetActiveCustomer,
} from './types/actions';
import { CeaseFormValues, CeaseRequestDetails, CeaseRequestType } from './types/cease';

export const setActiveCustomer = (customerId: string): ISetActiveCustomer => ({
  type: CeaseActionTypes.SET_ACTIVE_CUSTOMER,
  payload: { customerId },
});

export const createCease = (payload: ICreateCease['payload']): ICreateCease => ({
  type: CeaseActionTypes.CREATE_CEASE,
  payload,
});

export const createCeaseStarted = (): ICreateCeaseStarted => ({
  type: CeaseActionTypes.CREATE_CEASE_STARTED,
});

export const createCeaseSuccess = (cease: CeaseRequestDetails): ICreateCeaseSuccess => ({
  type: CeaseActionTypes.CREATE_CEASE_SUCCESS,
  payload: { cease },
});

export const createCeaseError = (message: string): ICreateCeaseError => ({
  type: CeaseActionTypes.CREATE_CEASE_ERROR,
  payload: { message },
});

export const createCeaseEnded = (): ICreateCeaseEnded => ({
  type: CeaseActionTypes.CREATE_CEASE_ENDED,
});

export const getCeases = (payload: IGetCeases['payload']): IGetCeases => ({
  type: CeaseActionTypes.GET_CEASES,
  payload,
});

export const getCeasesStarted = (): IGetCeasesStarted => ({
  type: CeaseActionTypes.GET_CEASES_STARTED,
});

export const getCeasesSuccess = (ceases: CeaseRequestDetails[]): IGetCeasesSuccess => ({
  type: CeaseActionTypes.GET_CEASES_SUCCESS,
  payload: { ceases },
});

export const getCeasesError = (message: string): IGetCeasesError => ({
  type: CeaseActionTypes.GET_CEASES_ERROR,
  payload: { message },
});

export const getCeasesEnded = (): IGetCeasesEnded => ({
  type: CeaseActionTypes.GET_CEASES_ENDED,
});

export const getCease = (payload: IGetCease['payload']): IGetCease => ({
  type: CeaseActionTypes.GET_CEASE,
  payload,
});

export const getCeaseStarted = (): IGetCeaseStarted => ({
  type: CeaseActionTypes.GET_CEASE_STARTED,
});

export const getCeaseSuccess = (cease: CeaseRequestDetails): IGetCeaseSuccess => ({
  type: CeaseActionTypes.GET_CEASE_SUCCESS,
  payload: { cease },
});

export const getCeaseError = (message: string): IGetCeaseError => ({
  type: CeaseActionTypes.GET_CEASE_ERROR,
  payload: { message },
});

export const getCeaseEnded = (): IGetCeaseEnded => ({
  type: CeaseActionTypes.GET_CEASE_ENDED,
});

export const resetCeaseError = (): IResetCeaseError => ({
  type: CeaseActionTypes.RESET_CEASE_ERROR,
});

export const buildCreateCeaseFormDefaults = (
  customerName: string,
  submittedBy: string,
  primaryContactName: string,
  primaryContactEmail: string
): CeaseFormValues => ({
  requestType: CeaseRequestType.CeaseRequest,
  customerName,
  submittedBy,
  primaryContactName,
  primaryContactEmail,
  primaryContactPhone: '',
  secondaryContactEmail: '',
  idn: '',
  requestedCeaseDate: null,
  ceaseReason: '',
  details: '',
  customerReference: '',
});
